module.exports = "/assets/fonts/vendor/@mdi/materialdesignicons-webfont.eot?2d0a0d8f5f173be15a67aa084db94fe6";